/* eslint-disable no-magic-numbers */

import { trimStart } from 'lodash';

/**
 * Multiplies a numeric string by 100, preserving decimal places.
 * @param value - The numeric string to be multiplied
 * @param divider - The decimal separator used in the string (default is '.')
 */
export const multiplyNumberStrBy100 = (value: string, divider = '.') => {
  if (value.indexOf(divider) !== -1) {
    const parts = value.split(divider);
    const newLeft = [parts[0], parts[1][0] || '0', parts[1][1] || '0'].join('');
    const newRight = [divider, parts[1].padEnd(4, '0').substring(2)].join('');
    return `${trimStart(newLeft, '0') || '0'}${newRight}`;
  } else {
    return `${value}00`;
  }
};
